// services/orgService.js
import api from "./api";

export const getAllOrgs = async () => {
  try {
    const response = await api.get("/orgs/");
    return response.data;
  } catch (error) {
    console.error("Error fetching organizations:", error);
    throw error;
  }
};

export const getOrgById = async (orgId) => {
  try {
    const response = await api.get(`/orgs/${orgId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching organization with ID ${orgId}:`, error);
    throw error;
  }
};

export const createOrg = async (orgData) => {
  try {
    const response = await api.post("/orgs/", orgData);
    return response.data;
  } catch (error) {
    console.error("Error creating organization:", error);
    throw error;
  }
};

export const updateOrg = async (orgId, orgData) => {
  try {
    const response = await api.put(`/orgs/${orgId}/`, orgData);
    return response.data;
  } catch (error) {
    console.error(`Error updating organization with ID ${orgId}:`, error);
    throw error;
  }
};

export const deleteOrg = async (orgId) => {
  try {
    await api.delete(`/orgs/${orgId}/`);
  } catch (error) {
    console.error(`Error deleting organization with ID ${orgId}:`, error);
    throw error;
  }
};

// Optional: Add pagination support
export const getOrgsWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-created_at",
  status = null,
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (status) params.append("status", status);

    const response = await api.get("/orgs/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching organizations with pagination:", error);
    throw error;
  }
};

// Optional: Add organization member management
export const addOrgMember = async (orgId, userData) => {
  try {
    const response = await api.post(`/orgs/${orgId}/members/`, userData);
    return response.data;
  } catch (error) {
    console.error("Error adding organization member:", error);
    throw error;
  }
};

export const removeOrgMember = async (orgId, userId) => {
  try {
    await api.delete(`/orgs/${orgId}/members/${userId}/`);
  } catch (error) {
    console.error("Error removing organization member:", error);
    throw error;
  }
};

export const updateOrgMember = async (orgId, userId, userData) => {
  try {
    const response = await api.put(
      `/orgs/${orgId}/members/${userId}/`,
      userData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating organization member:", error);
    throw error;
  }
};

// Optional: Add organization settings management
export const getOrgSettings = async (orgId) => {
  try {
    const response = await api.get(`/orgs/${orgId}/settings/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching organization settings:", error);
    throw error;
  }
};

export const updateOrgSettings = async (orgId, settingsData) => {
  try {
    const response = await api.put(`/orgs/${orgId}/settings/`, settingsData);
    return response.data;
  } catch (error) {
    console.error("Error updating organization settings:", error);
    throw error;
  }
};
